import type { FormatIntlParams } from './types';
import { getFormatter, locales, resolveFormatIntlType } from './utils';

/**
 * Formats date, time, or date-time values using Intl.DateTimeFormat.
 *
 * Supports both single values and ranges (start → end).
 *
 * Range behavior:
 * Intl.DateTimeFormat automatically:
 * - omits repeating parts when possible (e.g. same day → shows date once)
 * - expands both values when needed (e.g. different days)
 *
 */
export const formatIntl = (params: FormatIntlParams): string => {
  const { end, lang = 'en', start } = params;
  const locale = locales[lang];
  const startDate = new Date(start);
  const endDate = end ? new Date(end) : undefined;

  const formatter = getFormatter({
    locale,
    type: resolveFormatIntlType(params),
  });

  if (endDate) {
    return formatter.formatRange(startDate, endDate);
  }

  return formatter.format(startDate);
};
